module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    staticClass: "main-canvas",
    attrs: {
      "id": "canvas"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-646b1b2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/stamp.vue
// module id = 855
// module chunks = 34